import React, { Component, Fragment } from "react";
import { inject, observer } from "mobx-react";
import joint from "rappid";
import {
	Icon,
	Tooltip,
	Divider,
	Button,
	Form,
	Card,
	Row,
	Drawer,
	AutoComplete,
	Tabs
} from "antd";
import { autorun } from "mobx";
import { Guides } from "common/guides";

import { locationPrefix } from "common/general";
import App from "components/DiagramDesigner";
import PageHeaderLayout from "layouts/PageHeaderLayout";
import co from "co";
import FileSaver from "file-saver";
import TextArea from "antd/lib/input/TextArea";

const FormItem = Form.Item;
const TabPane = Tabs.TabPane;

@Form.create({
	onFieldsChange(props, changedFields) {
		props.onFieldsChange(props.projectId, changedFields);
	},

	mapPropsToFields(props) {
		return props.fields;
	}
})
class InspectorForm extends Component {
	render() {
		return (
			<FormItem label="Account Store Name">
				{this.props.form.getFieldDecorator(
					`projects.${this.props.projectId}.profileName`
				)(
					<AutoComplete
						defaultActiveFirstOption={false}
						style={{ width: 250 }}
						dataSource={this.props.profileNameDataSource}
						placeholder="Enter Account Store Name"
					/>
				)}
			</FormItem>
		);
	}
}

@inject("rootStore")
@observer
class InspectorDrawer extends Component {
	hideInspector = () => {
		const {
			rootStore: { strategyStore }
		} = this.props;

		strategyStore.hideInspector();
	};

	onFieldsChange = (projectId, changedFields) => {
		const {
			rootStore: { strategyStore }
		} = this.props;

		this.props.onFieldsChange(projectId, changedFields);
		strategyStore.formChanged(changedFields);
	};

	mapPropsToFields = () => {
		const {
			rootStore: { strategyStore }
		} = this.props;

		const ui = strategyStore.ui;
		const stateForm = strategyStore.stateForm;

		let data = {
			projects: {}
		};
		// let currentProjectId = ui.projectId;
		// if (currentProjectId) {
		// 	console.log("Current Project Id is " + currentProjectId);
		// 	data.projects[currentProjectId] = {
		// 		profileName: Form.createFormField(
		// 			stateForm.projects[currentProjectId].profileName
		// 		)
		// 	};
		// }
		Object.keys(stateForm.projects).forEach(function(key) {
			data.projects[key] = {
				profileName: Form.createFormField(
					stateForm.projects[key].profileName
				)
			};
		});

		return data;
	};

	render() {
		const {
			rootStore: { strategyStore }
		} = this.props;

		const ui = strategyStore.ui;
		let fields = this.mapPropsToFields();
		let profileNameDataSource = strategyStore.profileNameDataSource;

		return (
			<Drawer
				title={ui.projectName}
				placement="right"
				closable={false}
				onClose={this.hideInspector}
				visible={ui.inspectorVisible}
				width={300}
			>
				<InspectorForm
					projectId={ui.projectId}
					onFieldsChange={this.onFieldsChange}
					profileNameDataSource={profileNameDataSource}
					fields={fields}
				/>
			</Drawer>
		);
	}
}


@Form.create({
	mapPropsToFields(props) {
		return props.fields;
	}
})
class DescriptionForm extends Component {	
	getDescription = () => {
		return this.props.form.getFieldValue("description");
	}
	render() {
		return (
			<FormItem label="Description">
				{this.props.form.getFieldDecorator("description")(<TextArea />)}				
			</FormItem>
		)
	}
}

@inject("rootStore")
@observer
class StrategyDesigner extends Component {
	layoutGraph = () => {
		this.app.layoutDirectedGraph();
	};
	zoomIn = () => {
		this.app.zoomIn();
	};
	zoomOut = () => {
		this.app.zoomOut();
	};
	downloadGraph = () => {
		co(
			function*() {
				const result = yield this.app.exportDiagram();		
				var diagramContent = new Blob([JSON.stringify(result)], {type: 'application/json'});		
				FileSaver.saveAs(diagramContent, "test.json");
			}.bind(this)
		);		
	};

	saveDiagram = () => {
		const {
			rootStore: { strategyStore }
		} = this.props;
		co(
			function*() {
				const result = yield this.app.exportDiagram();
				const description = this.descriptionForm ? this.descriptionForm.getDescription() : "";
				const strategObj = { ...result, description }
				// console.log("Payload is ", strategObj);
				strategyStore.saveDiagram(strategObj);
			}.bind(this)
		);
	};

	componentWillUnmount() {
		if (
			this.strategyDisposer != undefined &&
			this.strategyDisposer != null
		) {
			this.strategyDisposer();
		}
	}

	showInspector = model => {
		const {
			rootStore: { strategyStore }
		} = this.props;
		strategyStore.showInspector(model);
	};

	hideInspector = () => {};

	removeProject = projectId => {
		const {
			rootStore: { strategyStore }
		} = this.props;
		strategyStore.removeProject(projectId);
	};

	componentDidMount = () => {
		const {
			rootStore: { strategyStore }
		} = this.props;

		const diagram = strategyStore.strategy;

		joint.setTheme("modern");
		let app = (this.app = new App.MainView({
			el: "#app",
			paperContainerEl: "#paperContainer",
			navigatorContainerEl: "#navigatorContainer",
			stencilContainerEl: "#stencilContainer",
			mainPage: this
		}));

		this.strategyDisposer = autorun(() => {
			if (strategyStore.strategy.id != null) {
				this.app.loadDiagram(
					JSON.parse(strategyStore.strategy.strategy)
				);
				this.app.paperScroller.zoomToFit({
					padding: 50,
					maxScaleX: 1,
					maxScaleY: 1
				});
				// const moneySite = this.app.graph.getCell("moneySite");
				// this.app.paperScroller.centerElement(moneySite);
			}
		});
	};

	onFieldsChange = (projectId, changedFields) => {
		if (changedFields.projects && changedFields.projects[projectId]) {
			let project = changedFields.projects[projectId];
			if (project.profileName) {
				let value = project.profileName.value;
				if (value != undefined && value != null) {
					let cell = this.app.graph.getCell(projectId);
					cell.attr("bodyText/text", value);
					cell.attr("custom/profileName", value);
				}
			}
		}
	};

	mapPropsToFields = () => {
		const {
			rootStore: { strategyStore }
		} = this.props;	
		const strategy = strategyStore.strategy;
		// console.log("Strategy is", strategy);
		return {
			description:  Form.createFormField({
				value: strategy.description
			})
		}	
	}

	render() {
		const {
			rootStore: { strategyStore }
		} = this.props;

		const ui = strategyStore.ui;

		let breadcrumbList = [
			{
				title: "Home",
				href: locationPrefix + "/"
			},
			{
				title: "Diagrams",
				href: locationPrefix + "/strategies"
			},
			{
				title: strategyStore.strategy.name
			}
		];

		return (
			<Fragment>
				<PageHeaderLayout breadcrumbList={breadcrumbList}>
					<Card>
						<Row>
							<Button
								type="primary"
								onClick={this.saveDiagram}
								loading={ui.savingStrategy}
							>
								Save
							</Button>
						</Row>
						<Tabs animated={false}>
							<TabPane tab="Diagram" key="Diagram">
								<InspectorDrawer
									onFieldsChange={this.onFieldsChange}
								/>
								<Row>
									<div
										id="app"
										style={{
											height: window.screen.height - 100
										}}
									>
										<div className="diagram-app-header">
											{/* <div className="app-title">
		<h1>Strategy</h1>
	</div> */}
											<Tooltip title="Download Diagram">
												<Button
													type="primary"
													shape="circle"
													onClick={this.downloadGraph}
												>
													<Icon type="download" />
												</Button>
											</Tooltip>
											<Divider type="vertical" />
											<Tooltip title="Auto-layout Diagram">
												<Button
													type="primary"
													shape="circle"
													onClick={this.layoutGraph}
												>
													<Icon type="layout" />
												</Button>
											</Tooltip>
											<Divider type="vertical" />
											<Tooltip title="Zoom In">
												<Button
													type="primary"
													shape="circle"
													onClick={this.zoomIn}
												>
													<Icon type="plus-circle-o" />
												</Button>
											</Tooltip>
											<Divider type="vertical" />
											<Tooltip title="Zoom Out">
												<Button
													type="primary"
													shape="circle"
													onClick={this.zoomOut}
												>
													<Icon type="minus-circle-o" />
												</Button>
											</Tooltip>
											<Divider type="vertical" />
											<Tooltip title="How to use strategy designer">
												<a
													href={
														Guides["strategy-designer"]
													}
													target="_blank"
													className="ant-btn ant-btn-primary ant-btn-circle"
												>
													<Icon
														type="question-circle"														
													/>
												</a>
											</Tooltip>
										</div>
										<div className="app-body">
											<div
												className="stencil-container"
												id="stencilContainer"
											/>
											<div
												className="paper-container"
												id="paperContainer"
											/>
											{/* <div className="inspector-container" /> */}
											<div
												className="navigator-container"
												id="navigatorContainer"
											/>
										</div>
									</div>
								</Row>
							</TabPane>							
							<TabPane tab="Description" key="Description" forceRender={true}>
								<DescriptionForm
									fields={this.mapPropsToFields()} 
									wrappedComponentRef={internalForm => {
										if (internalForm != null) {
											this.descriptionForm = internalForm;
										}
									}}
								/>
							</TabPane>	
						</Tabs>
					</Card>
				</PageHeaderLayout>
			</Fragment>
		);
	}
}

export default StrategyDesigner;
